// extracted by mini-css-extract-plugin
export default {"wrapper":"searchContact_wrapper__NnDO3","title":"searchContact_title__aI2fF","input":"searchContact_input__OU0Ph"};